/* eslint-disable no-magic-numbers */

// 字号列表
export const FONT_GROUP = [12, 14, 16, 18, 20, 22, 24, 26, 28, 32, 34, 36];
// 默认字号
export const DEFAULT_FONT_SIZE = 18;
// 默认亮度
export const DEFAULT_BRIGHTNESS = 100;

// 亮度阈值
export const BRIGHTNESS_THRESHOLD = 0.8;

// 阅读器主题
export type TReaderTheme = 'white' | 'yellow' | 'green' | 'night';
// 默认主题
export const DEFAULT_THEME = 'white';

// 主题列表
export const THEME_LIST: { key: TReaderTheme; label: string }[] = [
    { key: 'white', label: 'White' },
    { key: 'yellow', label: 'Eye Care' },
    { key: 'green', label: 'Green' },
    { key: 'night', label: 'Night' },
];

// ── 无限滚动 / 章节渲染区配置 ─────────────────────────────────
/** 渲染区中同时渲染的最大章节数，超过后回收远端章节 */
export const RENDER_LIST_MAX_CHAPTERS = 6;
/** 超过 MAX 后保留的章节数（锚点 + 前后各 1） */
export const RENDER_LIST_TRIM_KEEP = 3;
/** 章节内存缓存上限（从渲染区回收的章节仍保留在缓存中，LRU 淘汰） */
export const CHAPTER_CACHE_MAX_SIZE = 20;
/**
 * IntersectionObserver threshold 分档数。
 * 以元素面积为基准划分 N 档，即使章节远长于视口，
 * 每滚动约 1/N 个元素高度就触发一次回调，保证 intersectionRect.height 持续更新。
 */
export const ANCHOR_THRESHOLD_STEPS = 10;

// 阅读器章节请求超时时间
export const CHAPTER_REQUEST_TIMEOUT = 10000;

// 轮询等待某章节的 loading 标记消失的时间间隔
export const CHAPTER_REQUEST_INTERVAL = 150;
